import { transportTimeoutMs, withAbortTimeout } from '../helpers/transport-timeout.helpers';

// Raw PUT of a file body to a pre-signed storage URL (e.g. a GCS V4 signed write URL). This is
// not a Max-server call, so it deliberately bypasses RestService: the host is the signed URL's,
// and credentials must NOT be sent — the signature is the whole authorization.
export const uploadFileToSignedUrl = async (
  uploadUrl: string,
  file: Blob,
  contentType: string,
): Promise<void> => {
  const response = await withAbortTimeout('signed upload', transportTimeoutMs('long'), (signal) => fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
    signal,
  }));
  if (!response.ok) {
    throw new Error(`Signed upload failed with HTTP ${response.status}`);
  }
};
